import React from "react";
import Styles from './styles.module.scss'

import Seo from "../../components/_UI/seo";
import {useTranslation} from "react-i18next";
import AuthRedirect from "../../components/authRedirect";
import CabinetWalletBalance from "../../components/cabinet/cabinetWalletBalance";
import CabinetWalletMarketOverview from "../../components/cabinet/cabinetWalletMarketOverview";
import CabinetWalletAssets from "../../components/cabinet/cabinetWalletAssets";
import CabinetWalletHistory from "../../components/cabinet/cabinetWalletHistory";
import CabinetWalletReceiveModal from "../../components/cabinet/cabinetWalletReceiveModal";
import CabinetWalletSendModal from "../../components/cabinet/cabinetWalletSendModal";
import CabinetSubscribeWarning from "../../components/cabinet/cabinetSubscribeWarning";
import CabinetWalletSubscribeModal from "../../components/cabinet/cabinetWalletSubscribeModal";
import {useSelector} from "react-redux";



const CabinetWalletPage = () => {
    const { t } = useTranslation();
    const userData = useSelector(store => store.cabinet.userData);

    const isWarningNeed = userData && userData?.subscription_status !== "active";

    return (
        <section className={`${Styles.container} ${Styles.cabinetPC}`}>
            <Seo title={t('Кошелек')}/>
            <AuthRedirect isCabinet={true}/>
            <div className={`${Styles.cabinetNote}`}>{t('Добро пожаловать в ваш криптокошелёк Kairo')}</div>
            {isWarningNeed ? <CabinetSubscribeWarning/> : null}
            <div className={`${Styles.posWrap}`}>
                <CabinetWalletBalance/>
                <CabinetWalletMarketOverview/>
                <CabinetWalletAssets/>
                <CabinetWalletHistory/>
            </div>
            <CabinetWalletReceiveModal/>
            <CabinetWalletSendModal/>
            <CabinetWalletSubscribeModal/>
        </section>
    );
};

export default CabinetWalletPage;